export var KPI;
(function (KPI) {
    KPI["GPR"] = "GPR";
    KPI["BPR"] = "BPR";
    KPI["GCR"] = "GCR";
})(KPI || (KPI = {}));
;
export var PSAO;
(function (PSAO) {
    PSAO["APCI"] = "APCI";
    PSAO["AAP"] = "AAP";
    PSAO["AAPA"] = "AAPA";
    PSAO["APSC"] = "APSC";
    PSAO["EPIC"] = "EPIC";
    PSAO["CARE"] = "CARE";
    PSAO["IPC"] = "IPC";
    PSAO["NPSC"] = "NPSC";
    PSAO["CPA"] = "CPA";
    PSAO["Smart_Fill"] = "Smart Fill";
    PSAO["APRX"] = "APRX";
    PSAO["Aspire"] = "Aspire";
    PSAO["IPB"] = "IPB";
    PSAO["IPA"] = "IPA";
    PSAO["PharmaGroup"] = "PharmaGroup";
    PSAO["Nexus_Pharmacy_Alliance"] = "Nexus Pharmacy Alliance";
    PSAO["Sav_Mor"] = "Sav-Mor";
    PSAO["Montana_Family_Pharmacies"] = "Montana Family Pharmacies";
    PSAO["WSPC"] = "WSPC";
    PSAO["OTHER"] = "Other";
})(PSAO || (PSAO = {}));
;
;
;
